import React from "react";
import "./Language.scss";
import { EditOutlined } from "@ant-design/icons";
import { TUserSectionProp } from "@utils/Interfaces";
import { Empty, Skeleton } from "antd";

const Language: React.FC<TUserSectionProp> = ({
  setIsEditProfileVisible,
  setActiveTab,
  userProfile,
  loading,
}) => {
  return (
    <div className="card card-profile language">
      <div
        className="edit-action"
        onClick={() => {
          setIsEditProfileVisible(true);
          setActiveTab("7");
        }}
      >
        <EditOutlined />
      </div>
      <div className="card-title">Language</div>
      <div
        className={`language-group ${
          userProfile.languages?.length == 0 || userProfile.languages == null
            ? "justify-content-center"
            : ""
        }`}
      >
        {!loading ? (
          <Skeleton active />
        ) : userProfile.languages?.length == 0 ||
          userProfile.languages == null ? (
          <Empty />
        ) : (
          userProfile.languages.map((item, index) => {
            return (
              <div className="lang-item" key={index}>
                <span>{item}</span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default Language;
